import axios from 'axios';

import { LEAVE_TYPES } from 'components/roster-portal/capacity/Formation/const';

import { SCENARIO_CAPACITY_SETTINGS } from '../endpoints';

export type SaveCapacitySettingsPayload = {
  leaveType: keyof typeof LEAVE_TYPES;
};

export type CapacitySettingsResponse = {
  scenarioId: number;
  leaveType: keyof typeof LEAVE_TYPES;
};

export const getCapacitySettings = (scenarioId: number, year) =>
  axios.get<CapacitySettingsResponse>(SCENARIO_CAPACITY_SETTINGS, {
    pathParams: { scenarioId, year }
  });

export const saveCapacitySettings = ({
  scenarioId,
  year,
  payload
}: {
  scenarioId: number;
  year: number;
  payload: SaveCapacitySettingsPayload;
}) =>
  axios.post(SCENARIO_CAPACITY_SETTINGS, payload, {
    pathParams: { scenarioId, year }
  });
